import { render, staticRenderFns } from "./tarihegore.vue?vue&type=template&id=0e9102c2&scoped=true"
import script from "./tarihegore.vue?vue&type=script&lang=js"
export * from "./tarihegore.vue?vue&type=script&lang=js"
import style0 from "./tarihegore.vue?vue&type=style&index=0&id=0e9102c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9102c2",
  null
  
)

export default component.exports